// src/utils/categoryUtils.js

// Configurazione categorie (spostala qui dal FilterPanel)
export const CATEGORY_STYLES = {
  'Free Palestine': {
    color: '#ff0000ff',
    icon: 'fas fa-calendar-alt',
    categoryIds: [35],
    name: 'Free Palestine'
  },
  'spettacolo': {
    color: '#e74c3c',
    icon: 'fas fa-theater-masks',
    categoryIds: [16, 2, 18, 17, 3],
    name: 'Spettacolo'
  },
  'musica': {
    color: '#e74c3c',
    icon: 'fas fa-music',
    categoryIds: [16, 2, 18, 17, 1, 3, 27, 26, 25, 24, 23, 22, 28, 29, 32],
    name: 'Musica'
  },
  'culinaria': {
    color: '#f39c12',
    icon: 'fas fa-utensils',
    categoryIds: [4, 9],
    name: 'Enogastronomia'
  },
  'sport': {
    color: '#27ae60',
    icon: 'fas fa-running',
    categoryIds: [20, 7, 21],
    name: 'Sport & Movimento'
  },
  'cultura': {
    color: '#9b59b6',
    icon: 'fas fa-university',
    categoryIds: [10, 5, 15, 19, 34],
    name: 'Arte & Cultura'
  },
  'eventi': {
    color: '#e91e63',
    icon: 'fas fa-calendar-star',
    categoryIds: [8],
    name: 'Festival & Eventi'
  },
  'natura': {
    color: '#2ecc71',
    icon: 'fas fa-leaf',
    categoryIds: [11],
    name: 'Natura & Outdoor'
  },
  'lifestyle': {
    color: '#f1c40f',
    icon: 'fas fa-star',
    categoryIds: [14],
    name: 'Lifestyle & Formazione'
  },
  'digitale': {
    color: '#34495e',
    icon: 'fas fa-laptop',
    categoryIds: [33],
    name: 'Tech'
  },
  'default': {
    color: '#95a5a6',
    icon: 'fas fa-calendar-alt',
    categoryIds: [],
    name: 'Altri Eventi'
  }
};

// Funzione per ottenere la macro categoria
export const getMacroCategoryForCategory = (categoryId) => {
  for (const [macroKey, config] of Object.entries(CATEGORY_STYLES)) {
    if (config.categoryIds.includes(categoryId)) {
      return config;
    }
  }
  return CATEGORY_STYLES.default;
};
